module.exports = __webpack_public_path__ + "045c384589187ad2dec6bae719f903cb.fbx";